import { FC } from "react";
import {
  MDSButton,
  MDSIcon,
  MDSIconColor,
  MDSIconKind,
  MDSRowItem,
  MDSRowItemAppearance,
  MDSRowItemSlotName,
  MDSText,
  MDSTextColor,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { MDSPanelWidths } from "@/mds/foundations";
import styled from "@emotion/styled";

export interface CalendarIntegrationNotConnectedContentViewProps {
  onClick: () => void;
}

export const CalendarIntegrationNotConnectedContentView: FC<
  CalendarIntegrationNotConnectedContentViewProps
> = ({ onClick }) => {
  return (
    <MDSRowItem
      $isSelected={false}
      $isHighlighted={false}
      $isSpecial={false}
      $mustClickOnRowTitle={false}
      $appearance={MDSRowItemAppearance.Standard}
      onClick={onClick}
    >
      <StyledIconWrapper slot={MDSRowItemSlotName.LeftAddon}>
        <MDSIcon size={18} kind={MDSIconKind.Calendar} color={MDSIconColor.Placeholder} />
      </StyledIconWrapper>

      <ContentRow>
        <Content>
          <LabelContainer>
            <MDSText
              variant={MDSTextVariant.TextM}
              weight={MDSTextWeight.Medium}
              color={MDSTextColor.Secondary}
            >
              Remember every meeting
            </MDSText>
          </LabelContainer>
        </Content>
      </ContentRow>

      <DesktopButton slot={MDSRowItemSlotName.RightAddon} onClick={onClick}>
        Connect your calendar
      </DesktopButton>

      <BottomRow slot={MDSRowItemSlotName.BottomAddon}>
        <MDSText variant={MDSTextVariant.TextS} color={MDSTextColor.Secondary}>
          Let Mem automatically take meeting notes for you with the calendar integration
        </MDSText>
        <MobileButton onClick={onClick}>Connect your calendar</MobileButton>
      </BottomRow>
    </MDSRowItem>
  );
};

const DesktopButton = styled(MDSButton)`
  @container mds-row-item (max-width: ${MDSPanelWidths.narrow}px) {
    display: none;
  }
`;

const MobileButton = styled(MDSButton)`
  display: none;

  @container mds-row-item (max-width: ${MDSPanelWidths.narrow}px) {
    display: inline-flex;
    width: fit-content;
  }
`;

const ContentRow = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-shrink: 1;
`;

const Content = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
`;

const LabelContainer = styled.div`
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing["2"]};
`;

const StyledIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  min-width: fit-content;
  align-self: stretch;
  padding-right: ${({ theme }) => theme.spacing["3"]};
  padding-top: 6px;
`;
